import { createFileRoute } from '@tanstack/react-router';
import { ConversationView } from '@/components/ConversationView';
import { Id } from '@pronteer/convex/dataModel';

export const Route = createFileRoute('/_auth/conversations/$conversationId')({
  component: ConversationDetailRoute,
});

function ConversationDetailRoute() {
  const { conversationId } = Route.useParams();

  return <ConversationView conversationId={conversationId as Id<'conversations'>} />;
}
